import lottie from "lottie-web";
import {generals} from "./parts/generals.js";
import {video} from "./parts/video.js";
import {who} from "./parts/who.js";
import {products} from "./parts/products.js";
import {reviews} from "./parts/reviews.js";
import {faq} from "./parts/faq.js";
import {footer} from "./parts/footer.js";
import {keyFeatures} from "./parts/key-features.js";
import {reviews2} from "./parts/reviews-2.js";
import {features} from "./parts/features.js";
import {benefits} from "./parts/benefits.js";
import {cases} from "./parts/cases.js";
import {productHero} from "./parts/product-hero.js";
export const animations = ()=> {

    generals();

    productHero();

    video()

    who()

    products();

    reviews();

    reviews2();

    faq();

    features();

    benefits();

    cases();

    footer();

    keyFeatures(lottie)

}